import React from 'react';
import { Link } from 'react-router-dom';
import { BreadCrumbItem } from '../../types';

interface BreadCrumbCmpProps {
  items: BreadCrumbItem[];
}

export default function BreadCrumbCmp(props: BreadCrumbCmpProps) {
  function renderItem(item: BreadCrumbItem) {
    if (!item.isLast) {
      return (
        <React.Fragment>
          <Link to={item.link || '#'}>{item.title}</Link>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <span>{item.title}</span>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="breadcrumb">
        {props.items &&
          props.items.map((item) => (
            <span key={item.link} className="breadcrumb-item">
              {renderItem(item)}
            </span>
          ))}
      </div>
    </React.Fragment>
  );
}
